import axios from 'axios';
import { v4 as uuid } from 'uuid';
import { rootGizmoDataV3ToV2 } from '../../gizmos/utils';
import { IError, IGizmo, IRootGizmoData, IUserV2 } from '../../types';

interface IParams {
  config: IGizmo;
  rootGizmoData: IRootGizmoData;
  context: {
    apiUrl: string;
    user?: IUserV2;
  };
}

/**
 * Run the configured server validation flux script
 *
 * @param {IGizmo} config Gizmo's configuration
 * @param {IRootGizmoData} rootGizmoData RootGizmoData we're going to validate on the server
 *
 * @returns
 */
function serverValidation({
  config,
  rootGizmoData,
  context,
}: IParams): Promise<IError[]> {
  return new Promise<IError[]>(async resolve => {
    const { apiUrl, user } = context;
    const errors: IError[] = [];

    const url = `${apiUrl}/main_api/v1/root_gizmo/data/server_validation`;
    let headers = {};
    // Before sending to the server we're going to convert the rootGizmoData to v2
    const register = rootGizmoDataV3ToV2({ data: rootGizmoData });

    if (user?.credentials) {
      headers = {
        ...user.credentials,
      };
    }

    try {
      const response = await axios({
        method: 'POST',
        url,
        data: {
          gizmo_uid: config.uid,
          register,
        },
        headers,
      });

      if (response.status === 200) {
        const { data } = response;

        if (
          data.result !== undefined &&
          typeof data.result === 'boolean' &&
          data.result === false
        ) {
          if (config.ops?.serverValidation?.errorMessage) {
            errors.push({
              fid: uuid(),
              code: 'server-validattion',
              message: config.ops.serverValidation.errorMessage,
            });
          } else {
            errors.push({
              fid: uuid(),
              code: 'server-validattion',
              message: 'Error en la validación del servidor',
            });
          }
        } else if (
          data.result !== undefined &&
          typeof data.result === 'string'
        ) {
          errors.push({
            fid: uuid(),
            code: 'server-validattion',
            message: data.result,
          });
        }
      }
    } catch (e) {
      errors.push({
        fid: uuid(),
        code: 'server-validattion',
        message: 'Error en comunicación con el servidor',
      });
    }

    resolve(errors);
  });
}

export default serverValidation;
